import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Button from "@p1s/p1s-common-react/Button";
import { ssoLinkUser } from "../../actions/UserActions";
import LoginHelp from "../../components/common/LoginHelpWidget.jsx";
import InputError from "../../controls/InputError.jsx";
import classNames from "classnames";
import Logo from "../../components/common/Logo.jsx";
import UrlHelper from "../../utilities/UrlHelper";
import CookieManager from "../../utilities/CookieManager";
import { isEnterPressed } from "../../utilities/EventsHelper";
import TextInput from "../../controls/TextInput";
import ErrorResponse from "newApp/components/SelectorPages/ErrorResponse";

export class UserLinkingPage extends Component {
    constructor (props) {
        super(props);
        this.state = {
            capslock: false,
            loaded: true,
            siteId: CookieManager.getSsoSiteId(),
            userId: "",
            password: "",
            startLinking: false
        };

        this.handleEnterKey = this.handleEnterKey.bind(this);
        this.handlePasswordKeyPress = this.handlePasswordKeyPress.bind(this);

        this.handleLinkUserClick = this.handleLinkUserClick.bind(this);
        this.handleCancelClick = this.handleCancelClick.bind(this);
        this.fireLinkUserAction = this.fireLinkUserAction.bind(this);

        this.changeUserId = this.changeUserId.bind(this);
        this.changePassword = this.changePassword.bind(this);
    }

    handleEnterKey (e) {
        if (isEnterPressed(e)) {
            this.fireLinkUserAction();
        }
    }

    handlePasswordKeyPress (e) {
        var charCode = false;
        if (e.which) {
            charCode = e.which;
        } else if (e.keyCode) {
            charCode = e.keyCode;
        }
        var shifton = false;
        if (e.shiftKey) {
            shifton = e.shiftKey;
        } else if (e.modifiers) {
            shifton = !!(e.modifiers & 4);
        }

        if (charCode >= 97 && charCode <= 122 && shifton) {
            this.setState({ "capslock": true });
            return;
        }

        if (charCode >= 65 && charCode <= 90 && !shifton) {
            this.setState({ "capslock": true });
            return;
        }

        this.setState({ "capslock": false });
    }

    fireLinkUserAction () {
        const ticket = UrlHelper.parseUrl().query.ticket;
        this.setState({ startLinking: true });
        this.props.ssoLinkUser(this.state.siteId, this.state.userId, this.state.password, ticket).finally(() => {
            this.setState({ startLinking: false });
        });
    }

    handleLinkUserClick () {
        this.fireLinkUserAction();
    }

    handleCancelClick () {
        window.location = UrlHelper.getIdentifiUrl();
    }

    changeUserId (event) {
        const value = event.target.value;
        this.setState({ userId: value });
    }

    changePassword (event) {
        const value = event.target.value;
        this.setState({ password: value });
    }

    render () {
        if (this.props.redirectTo != null) {
            window.location = this.props.redirectTo;
        }

        var signInButtonClass = classNames("btn btn-primary-action pull-right", { "hidden": this.state.startLinking });
        var cancelButtonClass = classNames("btn pull-right", { "hidden": this.state.startLinking });
        var signInThrobberClass = classNames("throbberContainer", { "hidden": !this.state.startLinking });

        return (
            <div id="userLinkingPage">
                <div className="row userLinkingPageLogoRow">
                    <div className="col-md-2">&nbsp;</div>
                    <div className="col-md-3"><Logo/></div>
                </div>
                <div className="row signInRow">
                    <div className="col-md-2">&nbsp;</div>
                    <div className="col-md-9">
                        <h2> SSO User Linking</h2>

                        <div className="box">
                            <LoginHelp/>
                            <div className="siteid-login-row">
                                <div className="formControlTitle" style={{ display: "table-caption" }}>Site ID</div>
                                <input tabIndex="1"
                                    id="siteId" className="picker-hollow" type="text"
                                    defaultValue={this.state.siteId}
                                    disabled={true}/>
                            </div>

                            <div className="login-row">

                                <div className="formControlTitle">User ID</div>
                                <TextInput tabIndex={"2"}
                                    id="userId"
                                    onKeyUp={this.handleEnterKey}
                                    inputClassName="picker-hollow"
                                    onChange={this.changeUserId}
                                />
                            </div>

                            <div className="login-row m-b-0">

                                <div className="formControlTitle">Password</div>
                                <TextInput tabIndex={"3"} id="password"
                                    inputClassName="picker-hollow"
                                    onKeyUp={this.handleEnterKey}
                                    onKeyPress={this.handlePasswordKeyPress} onChange={this.changePassword}
                                    isPassword={true}
                                />
                            </div>
                            <div className="login-row">
                                <InputError label="CAPS Lock Is ON" visible={this.state.capslock}/>
                            </div>
                            <div id="buttonContainer">
                                <Button id="bSignIn"
                                    className={signInButtonClass}
                                    tabIndex="4"
                                    onClick={this.handleLinkUserClick}>
                                    Sign In
                                </Button>
                                <Button id="bCancel"
                                    className={cancelButtonClass}
                                    tabIndex="5"
                                    onClick={this.handleCancelClick}>
                                    Cancel
                                </Button>

                                <div id="loginThrobberContainer" className={signInThrobberClass}>
                                    <label>Loading</label>
                                    <div />
                                    {/*do not delete this empty div, it is used in css*/}
                                </div>
                            </div>

                            <ErrorResponse error={this.props.serverFailureMessage} title={"Login Failed"} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    componentDidMount () {
        import('./_linkStyles.scss');
        //Disable annoying CAPS LOCK warning in IE10/11
        document.msCapsLockWarningOff = true;
    }
}

UserLinkingPage.propTypes = {
    ssoLinkUser: PropTypes.func
};

const mapStateToProps = state => ({
    redirectTo: state.appState.redirectTo,
    serverFailureMessage: state.userState.serverFailureMessage
});

const mapDispatchToProps = (dispatch) => {
    return ({
        ssoLinkUser: (newPassword, currentPassword, userId, ticket) => dispatch(ssoLinkUser(newPassword, currentPassword, userId, ticket)),
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(UserLinkingPage);
